import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {filter} from 'rxjs/operators';
import {FormDataKeys} from '../../interfaces/fields-components';
import {FormAllData} from '../../interfaces/forms/form-element';

@Injectable()
export class FieldService {
  private fieldSubjectList$: Record<string, Record<string, BehaviorSubject<any>>> = {};

  constructor() {}

  private checkAddSubjectExhist(step: string, fieldName: string) {
    if (!this.fieldSubjectList$[step]) {
      this.fieldSubjectList$[step] = {} as Record<string, any>;
    }
    if (!this.fieldSubjectList$[step][fieldName]) {
      this.fieldSubjectList$[step][fieldName] = new BehaviorSubject(null);
    }
  }

  checkSubject(fieldName: string, step: string = 'unknownStep') {
    return typeof this.fieldSubjectList$?.[step]?.[fieldName] !== 'undefined';
  }

  setParamsMultiple(
    object: {[fieldName: string]: {[fieldKey: string]: any}},
    stepName: string = 'unknownStep',
  ) {
    Object.keys(object).forEach((el) => {
      this.setParams(el as FormDataKeys, object[el], stepName);
    });
  }
  setParams(fieldName: string, value: {[fieldKey: string]: any}, step: string = 'unknownStep') {
    this.checkAddSubjectExhist(step, fieldName);
    this.fieldSubjectList$[step][fieldName].next(value);
  }

  getParams(fieldName: string, step: string = 'unknownStep'): Observable<FormAllData> {
    this.checkAddSubjectExhist(step, fieldName);
    return this.fieldSubjectList$[step][fieldName].asObservable().pipe(
      filter((el) => {
        return el && Object.keys(el).length > 0;
      }),
    );
  }

  getParamsSync(fieldName: string, step: string = 'unknownStep'): FormAllData | null {
    if (this.fieldSubjectList$?.[step]?.[fieldName]) {
      return this.fieldSubjectList$[step][fieldName].getValue();
    }
    return null;
  }

  deleteParam(fieldName: string, step: string = 'unknownStep') {
    if (this.fieldSubjectList$?.[step]?.[fieldName]) {
      // this.fieldSubjectList$?.[step][fieldName].complete();
      this.fieldSubjectList$?.[step][fieldName].unsubscribe();
      delete this.fieldSubjectList$[step][fieldName];
    }
  }

  deleteStepParams(step: string) {
    const list = (Object.keys(this.fieldSubjectList$?.[step] ?? {}) ?? []) as FormDataKeys[];
    list.forEach((el) => {
      this.deleteParam(el, step);
    });
  }

  destroy() {
    Object.keys(this.fieldSubjectList$).forEach((key: string) => {
      const l = Object.keys(this.fieldSubjectList$[key]) as FormDataKeys[];
      l.forEach((el: FormDataKeys) => {
        this.fieldSubjectList$[key][el].complete();
      });
      this.fieldSubjectList$[key] = {} as Record<FormDataKeys, BehaviorSubject<any>>;
    });
    this.fieldSubjectList$ = {};
  }
}
